module.exports = __webpack_public_path__ + "img/LOVAL-Will-Version_alone.70b6fa91.svg";